import { Form } from 'antd';
import { Button } from 'basic-ui-lib';
import BaseInput from 'basic-ui-lib/components/Input/BaseInput';
import InputPhone from 'basic-ui-lib/components/Input/InputPhone';
import { RadioButtons } from 'basic-ui-lib/components/RadioButtons';
import { FooterMobile } from 'layouts/widgets/BottomMobile';
import HeaderMobile from 'layouts/widgets/HeaderMobile';
import styled from 'styled-components';

const DetailInformation = () => {
  const [form] = Form.useForm();

  return (
    <Container>
      <HeaderMobile title='Detail Information' />
      <Content>
        <Form layout='vertical' form={form} onFinish={() => {}}>
          <Form.Item label='First Name' name='firstName'>
            <BaseInput placeholder='Please enter first name' />
          </Form.Item>
          <Form.Item label='Last Name' name='lastName'>
            <BaseInput placeholder='Please enter last name' />
          </Form.Item>
          <Form.Item label='Phone' name='phone'>
            <InputPhone placeholder='Please enter phone' />
          </Form.Item>
          <Form.Item label='Email' name='email'>
            <BaseInput placeholder='Please enter email' />
          </Form.Item>
          <Form.Item label='Position' name='position'>
            <RadioButtons
              options={[
                { label: 'Admin', value: 'ADMIN' },
                { label: 'Manager', value: 'MANAGER' },
              ]}
            />
          </Form.Item>
        </Form>
      </Content>
      <FooterMobile>
        <Button lg type_second>
          Update
        </Button>
      </FooterMobile>
    </Container>
  );
};

export default DetailInformation;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const Content = styled.div`
  flex: 1;
  padding: 24px 16px 0px;

  .ant-form-item {
    margin-bottom: 12px;
  }

  .ant-form-item-label > label {
    font-weight: 400;
    font-size: 14px;
  }
`;
